import { pathKey } from './path';

/** Communication domain query segments */
export const CommunicationQueryKeys = {
  threads: {
    detail: (threadUid: string) => [`task-messages/threads/${threadUid}`] as const,
  },
  callRecords: {
    detail: (uid: string) => [`call-records/${uid}`] as const,
    events: (uid: string) => [`call-records/${uid}/events`] as const,
    recording: (uid: string, recordingUid: string) => [`call-records/${uid}/recordings/${recordingUid}`] as const,
  },
  conversations: {
    detail: (path: string) => [path] as const,
  },
  assetTypes: {
    pathDetail: (uid: string) => pathKey(`asset-types/${uid}`),
  },
};
